export default "__VITE_ASSET__BYJgkNV1__"